import React, { Component } from 'react';
import { connect } from 'react-redux';

class NotFoundError extends Component {
  render() {
    return (
      <p>Page not found</p>
    );
  }
}

export default connect((state, props) => {
  return {};
})(NotFoundError);



// WEBPACK FOOTER //
// ./src/scenes/NotFoundError.js